module.exports = __webpack_public_path__ + "img/Differentiation-LICA_PLC.babb5f18.png";